/*
 * Enforce single-open <details> per .collapsible-content container.
 * Scopes by container so multiple independent accordions can exist on a page.
 */
(function () {
  'use strict';

  function initSingleOpen(container) {
    var detailsList = Array.prototype.slice.call(container.querySelectorAll('details'));
    if (!detailsList.length) return;

    detailsList.forEach(function (details) {
      details.addEventListener('toggle', function () {
        // Only act when this details becomes open
        if (!details.open) return;

        detailsList.forEach(function (d) {
          if (d !== details && d.open) {
            d.open = false;
          }
        });
      });
    });
  }

  function initAll() {
    var containers = document.querySelectorAll('.collapsible-content');
    Array.prototype.forEach.call(containers, initSingleOpen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
